import CloseIcon from "../../../assets/icons/CloseIcon";
import DownArrow from "../../../assets/icons/DownArrow";
import Tick from "../../../assets/icons/Tick";
import { ToasterCloseActionIcon, ToasterMobileHandleIcon } from "../../../assets/icons/ToasterIcons";
import UpArrow from "../../../assets/icons/UpArrow";
import { useUpload } from "../../../app/context/Upload/UploadContext";
import useIsMobile from "../../../app/hooks/useIsMobile";
import "./Toaster.css";
import React, { useEffect, useState } from "react";

const ToasterContainer = () => {
  const { uploadTasks, removeUpload, uploadTasksThumbnail, removeThumbnail } = useUpload();
  const [isOpen, setIsOpen] = useState(true);
  const isMobile = useIsMobile();
  const [showDialog, setShowDialog] = useState(false);
  const [pendingTask, setPendingTask] = useState<any>(null);
  const [hideToaster, setHideToaster] = useState(false);

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };

  const handleCancel = (task: any) => {
    setPendingTask(task);
    setShowDialog(true);
  };

  const confirmCancel = () => {
    if (pendingTask?.abortController) {
      pendingTask.abortController.abort();
    }
    removeUpload(pendingTask.id);
    setShowDialog(false);
    setPendingTask(null);
  };

  const cancelDialog = () => {
    setShowDialog(false);
    setPendingTask(null);
  };

  const successCount = uploadTasks?.filter(
    (task) => task.status === "success"
  ).length;

  const handleCloseToaster = () => {
    setHideToaster(true);
    removeUpload(null);

  };

  useEffect(() => {
    if (uploadTasks?.length > 0) {
      setHideToaster(false);
    }
  }, [uploadTasks]);

  const allUploadsComplete =
    uploadTasks.length > 0 &&
    uploadTasks.every((task) => task.status === "success");

  return (
    <>
      {!hideToaster && uploadTasks && uploadTasks.length > 0 && (
        <div className="toaster-container">
          {isMobile ? (
            <button
              className={`toaster-header-responsive ${
                isOpen ? "toaster-open" : ""
              }`}
              onClick={toggleAccordion}
            >
              <ToasterMobileHandleIcon />
            </button>
          ) : (
            <div className="toaster-header" onClick={toggleAccordion}>
              <span>
                {allUploadsComplete
                  ? `${successCount} Upload${
                      successCount > 1 ? "s" : ""
                    } Complete`
                  : `Uploading Files`}
              </span>
              <div className="toaster-header-actions">
                {allUploadsComplete ? (
                  <button
                    className="toaster-close-btn"
                    onClick={(e) => {
                      e.stopPropagation(); // prevent toggling accordion
                      handleCloseToaster();
                      removeThumbnail?.();
                    }}
                  >
                    <ToasterCloseActionIcon />
                  </button>
                ) : isOpen ? (
                  <UpArrow />
                ) : (
                  <DownArrow />
                )}
              </div>
            </div>
          )}
          {isOpen && (
            <div className="toaster-body">
              <div className="toaster">
                {uploadTasks?.map((task, index) => (
                  <div key={task.id} className="toaster-item">
                    <div className="toaster-item-info">
                      <div className="flex items-center justify-start gap-3 flex-1">
                        {uploadTasksThumbnail[index]?.type === "video" ? (
                          <video
                            src={`${uploadTasksThumbnail[index].url}`}
                            width={45}
                            height={70}
                          ></video>
                        ) : (
                          <img
                            src={`${uploadTasksThumbnail[index].url}`}
                            alt=""
                            width={45}
                            height={70}
                          />
                        )}

                        <div className="flex flex-col gap-2 flex-1">
                          <h2 className="flex items-center justify-between gap-2">
                            {task?.file?.name}
                            {task?.status === "uploading" && (
                              <button onClick={() => handleCancel(task)}>
                                <CloseIcon />
                              </button>
                            )}

                            {task?.status === "success" && (
                              <button>
                                <Tick />
                              </button>
                            )}
                          </h2>
                          {task?.status === "uploading" && (
                            <div className="toaster-progress-container">
                              <div className="toaster-item-progress">
                                <div
                                  className="toaster-item-progress-inner"
                                  style={{
                                    width: `${task?.progress}%`,
                                  }}
                                />
                              </div>
                              <p>{task?.progress}%</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {showDialog && (
        <div className="confirm-dialog-overlay">
          <div className="confirm-dialog">
            <p>
              Are you sure you want to cancel <br />
              <span>{pendingTask?.file?.name}</span> upload?
            </p>
            <div className="confirm-dialog-buttons">
              <button className="confirm-btn" onClick={confirmCancel}>
                Yes
              </button>
              <button className="cancel-btn" onClick={cancelDialog}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ToasterContainer;
